type CriteriaBadgeMessageProps = {
  criteriaTitle: string;
  success: boolean;
  formattedValue: string | number;
  hasCriteria: boolean;
  value: number;
  criteriaValue: number;
};

export const CriteriaBadgeMessage = ({
  criteriaTitle,
  success,
  formattedValue,
  hasCriteria,
  value,
  criteriaValue
}: CriteriaBadgeMessageProps) => {
  if (!hasCriteria) return null;

  const getMessage = () => {
    const isAboveCriteria = value > criteriaValue;
    const isBelowCriteria = value < criteriaValue;
    const isEqualCriteria = value === criteriaValue;

    switch (criteriaTitle) {
      case "Income to rent ratio":
      case "Current monthly income":
      case "Net income":
      case "Credit score":
        return [
          isAboveCriteria
            ? `Above your criteria of ${formattedValue}`
            : isBelowCriteria
              ? `Below your criteria of ${formattedValue}`
              : `Equal to your criteria of ${formattedValue}`,
          isAboveCriteria || isEqualCriteria
            ? "text-success-700"
            : "text-danger-600"
        ];
      case "Past due accounts":
      case "Balance past due":
      case "Balance of collections":
      case "Bankruptcy":
      case "Debt balance":
      case "Events reported":
        return [
          isBelowCriteria
            ? `Below your criteria of ${formattedValue}`
            : isAboveCriteria
              ? `Above your criteria of ${formattedValue}`
              : `Equal to your criteria of ${formattedValue}`,
          isBelowCriteria || isEqualCriteria
            ? "text-success-700"
            : "text-danger-600"
        ];
      case "National sex offender":
        return [
          success ? "Meets your criteria" : "Does not meet your criteria",
          success ? "text-success-700" : "text-danger-600"
        ];
      default:
        return ["Meets your criteria", "text-success-700"];
    }
  };

  const [message, textColor] = getMessage();

  return (
    <p className={`no-print text-sm font-medium ${textColor}`}>{message}</p>
  );
};
